// Identifiants Google, à renseigner une fois les comptes créés.
// Tant qu'ils sont vides, aucun script Google n'est chargé, même après acceptation des cookies.
const analyticsConfig = {
  // Google Analytics 4, ex. 'G-XXXXXXXXXX'
  ga4Id: '',
  // Google Ads, ex. 'AW-123456789'
  adsId: 'AW-18552001771',
  // Libellés des conversions Google Ads (Outils > Conversions), ex. 'AbC-D_efG-h12_34-567'
  adsConversionLabels: {
    lead: 'c5kqCKqOx7AdEOuppI5F',
    call: ''
  }
};

export default analyticsConfig;
